import {useEffect} from 'react';

import {useLocation} from 'react-router-dom';

import JobPostingsListViewAccordion from './ListViewAccordion';
import {WorkMode} from '../../../../../../types/WorkMode';
import {CompanyLocation, JobPosting} from '../../types/JobPostingsTypes';

interface JobPostingsListViewSummaryProps {
  active: JobPosting[];
  archived: JobPosting[];
  selected: string | null;
  appliedFilters: {
    department: string[];
    location: string[];
  };
  companyId: string;
  handleUpdateJobPosting(jobPosting: JobPosting): void;
  handleDeleteJobPosting(jobPosting: JobPosting): void;
  handleJobPostingStatusChange(jobPosting: JobPosting | undefined, action: 'archive' | 'activate'): void;
  companyLocations: CompanyLocation[];
  setSelected: (selected: string) => void;
}

export default function JobPostingsListViewSummary({
  active,
  archived,
  selected,
  appliedFilters,
  companyId,
  handleUpdateJobPosting,
  handleDeleteJobPosting,
  handleJobPostingStatusChange,
  companyLocations,
  setSelected,
}: JobPostingsListViewSummaryProps) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramsId = queryParams.get('id');

  const isParamsIdArchived = archived?.some((jobPosting) => jobPosting.resourceId === paramsId);
  useEffect(() => {
    if (paramsId && isParamsIdArchived) {
      setSelected('archived');
    }
  }, [paramsId, isParamsIdArchived, setSelected]);

  const filterByLocationAndDepartment = (jobPosting: JobPosting): boolean => {
    const departmentMatch =
      appliedFilters.department.length === 0 ||
      !!jobPosting.departments?.some((dep) => appliedFilters.department.includes(dep.resourceId));
    const locationMatch =
      appliedFilters.location.length === 0 ||
      jobPosting?.locations?.some((location) => appliedFilters.location.includes(location.resourceId)) ||
      (appliedFilters.location.includes(WorkMode.Remote) && jobPosting.remoteHiring);
    return departmentMatch && locationMatch;
  };

  const activeJobPostings = active?.filter(filterByLocationAndDepartment);

  const archivedJobPostings = archived?.filter(filterByLocationAndDepartment);

  return (
    <JobPostingsListViewAccordion
      jobPostings={selected === 'active' ? activeJobPostings : archivedJobPostings}
      companyId={companyId}
      handleUpdateJobPosting={handleUpdateJobPosting}
      handleDeleteJobPosting={handleDeleteJobPosting}
      handleJobPostingStatusChange={handleJobPostingStatusChange}
      companyLocations={companyLocations}
      paramsId={paramsId}
    />
  );
}
